export const FIND_CARE_PROVIDER_FAILURE = 'FIND_CARE_PROVIDER_FAILURE';

export const findCareProviderFailure = error => ({
    type: FIND_CARE_PROVIDER_FAILURE,
    payload: error,
    error: true,
});
